import Alert from "@amzn/meridian/alert";
import Link from "@amzn/meridian/link";
import React from "react";

export const NotificationAlert = ({
  title,
  message,
  link,
  linkMessage,
  openNewTab,
}) => {
  return (
    <div className="notification">
      <Alert title={title} type="warning">
        {message}
        <Link href={link} target={openNewTab ? "_blank" : ""}>
          {linkMessage}
        </Link>
      </Alert>
    </div>
  );
};

export default NotificationAlert;



// WEBPACK FOOTER //
// ./src/components/notification/NotificationAlert.js